import React from 'react';
import { connect } from 'react-redux';
import { FormGroup, Label } from 'reactstrap';
import { Input } from '@progress/kendo-react-inputs';
import { selectPayment } from '../../../../../../Redux/Actions/EndUser/BillingAction';
import { signupPlus, signupSubtract, resetSignup } from '../../../../../../Redux/Actions/SignupWizardActions';
import { setTransactionId } from '../../../../../../Redux/Actions/EndUser/StoreActions';
import { loader, toastr } from '../../../../../../Redux/Actions/CommonActions';
import IsLoading from '../../../../../Shared/Loading/IsLoading';
import axios from 'axios';
import { auth } from '../../../../../../services';
import { ROOT_API_URL } from '../../../../../../api-config';
import { history } from '../../../../../../helpers/history';
import SpanSpinner from '../../../../../Shared/SpanSpinner/SpanSpinner';

const successColor = "success";
const errorColor = "danger";
const warningColor = "warning";

class CardPayment extends React.Component {
    constructor(props) {
        super(props);

        console.log(this.props.membership);
        console.log(this.props.membership.membershipInformation);

        this.state = {
            NameOnCard:"",
            CardNumber: "",
            CardExpYear: "",
            CardExpMonth: "",
            CardCVC: "",
            IsAutoRenew: true,
            touched: {
                fullName: false,
                cardNumber: false,
                cardExpMonth: false,
                cardExpYear: false,
                cardCVC: false
            },
            states: [],
            isSubmitting: false
        };
    }

    cc_format(value) {
        var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
        var matches = v.match(/\d{4,16}/g);
        var match = matches && matches[0] || '';
        var parts = [];

        for (var i = 0; i < match.length; i += 4) {
            parts.push(match.substring(i, i + 4))
        }

        if (parts.length) {
            return parts.join(' ')
        } else {
            return value
        }
    }

    setAllTouchedTrue() {
        this.setState({
            touched: {
                fullName: true,
                cardNumber: true,
                cardExpMonth: true,
                cardExpYear: true,
                cardCVC: true
            }
        })
    }
    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    hadnleExpMonthChange = (event) => {
        var originalValue = this.state.CardExpMonth; //Get old input value
        let newVal = event.value.replace(/\s/g, '');                  //Get new input value 
        let isValid = true;

        if (!newVal.match(/(^[01]$|^[0][123456789]$|^[1][012]$|^$)/)) {
            isValid = false;
        }

        if (isValid) {
            this.setState({
                CardExpMonth: newVal
            }, function () {
                this.props.cardStateChange(this.state);
            });
        }
        else {
            this.setState({
                CardExpMonth: originalValue
            }, function () {
                this.props.cardStateChange(this.state);
            });
        }
    }

    hanleExpYearChange = (event) => {
        var originalValue = this.state.CardExpYear; //Get old input value
        const newVal = event.value.replace(/\s/g, '');                  //Get new input value 
        if ((newVal.match(/^(0)$|^([0-9][0-9]*)$|^$/) || newVal == "") && newVal.length <= 2) {
            this.setState({
                CardExpYear: newVal
            }, function () {
                this.props.cardStateChange(this.state);
            });
        }
        else {
            this.setState({
                CardExpYear: originalValue
            }, function () {
                this.props.cardStateChange(this.state);
            });
        }
    }

    hanleCVCChange = (event) => {
        var originalValue = this.state.CardCVC; //Get old input value
        const value = event.value.replace(/\D/g, '');//Get new input value 
        if ((value.match(/^[0-9999]|$/) || value == "") && value.length <= 4) {
            this.setState({
                CardCVC: value
            }, function () {
                this.props.cardStateChange(this.state);
            });
        }
        else {
            this.setState({
                CardCVC: originalValue
            }, function () {
                this.props.cardStateChange(this.state);
            });
        }
    }

    backBtnClick = () => {
        this.props.signupSubtract(this.props.signupWizard.signupStep);
    }

    shipping = () => {
        var total = 0;
        if (this.props.membership.addons && this.props.membership.addons.AddtoCartList.length > 0) {
            total = Number(total) + 8.25;
        }
        return (Number(total)).toFixed(2);
    }

    subTotal = () => {
        var total = Number(this.props.membership.membershipInformation.MembershipPackageObject.cost);
        if (this.props.membership.addons) {
            for (var i = 0; i < this.props.membership.addons.AddtoCartList.length; i++) {
                let product = this.props.membership.addons.AddtoCartList[i];
                if (product.discount) {
                    total = Number((Number(product.discount * product.quantity) + Number(total)).toFixed(2));
                }
                else {
                    total = Number((Number(product.cost * product.quantity) + Number(total)).toFixed(2));
                }               
            }
        }

        if (this.props.membership.donations) {
            for (var i = 0; i < this.props.membership.donations.length; i++) {
                let donation = this.props.membership.donations[i];
                total = (Number(donation.amount) + Number(total)).toFixed(2)
            }

        }

        return (Number(total)).toFixed(2);
    }

    tax = () => {
        var total = 0;
        if (this.props.membership.addons) {
            total += (Number(Number(Number(this.shipping() * 0.0825).toFixed(2)) + Number(total))).toFixed(2);

            for (var i = 0; i < this.props.membership.addons.AddtoCartList.length; i++) {
                let product = this.props.membership.addons.AddtoCartList[i];
                if (product.discount) {
                    total = Number(Number(Number(product.discount * product.quantity * 0.0825).toFixed(2)) + Number(total));
                }
                else {
                    total = Number(Number(Number(product.cost * product.quantity * 0.0825).toFixed(2)) + Number(total));
                } 
            }
        }
        return (Number(total)).toFixed(2);
    }

    total = () => {
        return this.subTotal();
    }

    grandTotal = () => {
        let SubTotal = Number(this.total()).toFixed(2);
        let Shipping = Number(this.shipping()).toFixed(2);
        let Tax = Number(Number(this.tax()).toFixed(2));
        let grandTotal = (Number(SubTotal) + Number(Shipping) + Number(Tax)).toFixed(2);

        return (Number(grandTotal)).toFixed(2);
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.isSubmitting) {
            this.props.toastr(true, 'Can only submitting 1 transaction at a time.', 'danger');
            return;
        }
        const userId = this.props.membership.userId;

        if (typeof(this.props.membership.membershipInformation.MembershipPackageId) === 'undefined') {
            this.props.membership.membershipInformation.MembershipPackageId =
                this.props.membership.membershipInformation.MembershipPackageObject.membershipPackageID;
        }
        //debugger;
        var signupObj = {
            MembershipViewModel: this.props.membership.membershipInformation,
            BillingInfoViewModel: this.props.billingInfo,
            NewsletterPreferences: this.props.membership.interests,
            AddonViewModel: this.props.membership.addons,
            DonationViewModel: this.props.membership.donations.map((donation) => {
                return ({
                    UserId: this.props.membership.membershipInformation.UserId,
                    SuggestedCost: Number(donation.amount),
                    ActualCost: Number(donation.amount),
                    Name: this.props.membership.membershipInformation.FirstName + " " + this.props.membership.membershipInformation.LastName,
                    DonationTypeId: donation.id,
                    Address1: this.props.membership.membershipInformation.MailingAddress1,
                    Address2: this.props.membership.membershipInformation.MailingAddress2,
                    City: this.props.membership.membershipInformation.MailingCity,
                    Zip: this.props.membership.membershipInformation.MailingZip,
                    Phone: this.props.membership.membershipInformation.Phone,
                    stateId: this.props.membership.membershipInformation.StateObject.id
                })
            }),
            ConfirmPaymentViewModel: {
                SubTotal: Number(this.subTotal()),
                Tax: Number(this.tax()), 
                GrandTotal: Number(this.grandTotal()), 
                ProductInvoiceLineItems: [
                    ...this.props.membership.addons.AddtoCartList.map((product) => {
                        return (
                            {
                                UserId: product.UserId,
                                Name: product.ProductName,
                                Quantity: Number(product.quantity),
                                UnitPrice: product.discount ? Number(product.discount) : Number(product.cost),
                                Amount: product.discount ? Number(product.discount) * Number(product.quantity) : Number(product.cost) * Number(product.quantity),
                                IsFulfilled: false,
                                Color: product.ColorId,
                                Size: product.SizeId,
                                CreateDate: Date.now,
                                IsMembership:false,
                                ProductId:product.productId
                            }
                        )
                    }),
                    ...this.props.membership.donations.map((donation) => {
                        return (
                            {
                                UserId: userId,
                                Name: donation.name,
                                Quantity: 1,
                                UnitPrice: Number(donation.amount),
                                Amount: Number(donation.amount),
                                IsFulfilled: false,
                                Color: "",
                                Size: "",
                                CreateDate: Date.now,
                                IsMembership:false
                            }
                        )
                    }),
                    {
                        UserId: userId ,
                        Name:this.props.membership.membershipInformation.MembershipPackageObject.description,
                        Quantity: 1,
                        UnitPrice: Number(this.props.membership.membershipInformation.MembershipPackageObject.cost),
                        Amount: Number(this.props.membership.membershipInformation.MembershipPackageObject.cost),
                        IsFulfilled: false,
                        Color:"",
                        Size:"",
                        CreateDate: Date.now,
                        IsMembership:true
                    }
                ],
                UserId: userId,
                ShippingCost: Number(this.shipping())
            }
        };

        console.log(signupObj);

        const options = { method: 'POST', headers: auth.authHeader() };
        if (this.isModelValid() && this.props.billingModelValid()) {
            this.props.loader(true);    
            this.setState({ isSubmitting: true });
            axios.post(`${ROOT_API_URL}/Signup/CreateMembership`, signupObj, options)
                .then((response) => {
                    //console.log('response');

                    this.props.loader(false);
                    this.setState({ isSubmitting: false });
                    this.props.resetSignup();
                    this.props.setTransactionId(response.data.transactionId);

                    history.push('/payment');

                }).catch((response) => {
                    // Show response.message by default. Use response.response.data.exceptionLanguage if exists
                    var err = response.message ? response.message : 'Network Connection Error';

                    if (response.response && response.response.data && response.response.data.exceptionLanguage) {
                        err = response.response.data.exceptionLanguage;
                    }

                    //console.log('catch');
                    window.scrollTo(0, 0);
                    this.props.loader(false);
                    this.setState({ isSubmitting: false });
                    this.props.toastr(true, err, errorColor);
                });
        } else {
            //console.log('else');
            this.props.loader(false);
            this.setState({ isSubmitting: false });
            this.setAllTouchedTrue();
            this.props.billingSetAllTouchedTrue();
        }
    }

    handleACHClick = (event) => {
        this.props.selectPayment("ACH")
    }

    isFreeAccount() {
        if (this.props.membership.selectedMembershipType && this.props.membership.selectedMembershipType.description === 'Free Account') {
            return true;
        } else {
            return false;
        }
    }

    handleCheckboxChange = event => {
        this.setState({ IsAutoRenew: event.target.checked }, 
            function() {
            this.props.cardStateChange(this.state);
        });
    }

    isModelValid() {
        if (!this.isFreeAccount()) {
            return this.state.NameOnCard !== "" &&
            this.state.CardNumber !== "" &&
            this.state.CardExpYear !== "" &&
            this.state.CardCVC !== "" &&
            this.state.CardExpMonth !== ""; 
        } else {
            return true;
        }
    }

    handleCreditNumChange = (event) => {
        var originalValue = this.state.CardNumber.replace(/\s/g, ''); //Get old input value
        const value = event.value.replace(/\s/g, '').replace(/\D/g, '');              //Get new input value 
        if ((value.match(/^[0-9999999999999999]|^$/) || value == "") && value.length <= 16) {
            this.setState({
                CardNumber: this.cc_format(value)
            }, function () {
                this.props.cardStateChange(this.state);
            });
        }
        else {
            this.setState({
                CardNumber: this.cc_format(originalValue)
            }, function () {
                this.props.cardStateChange(this.state);
            });
        }
    }

    render() {
        return (
            <div className="paymentContainer">
                <h3 className="main-title mb-2">Enter your <span className="highlight">card</span> information</h3>
                <FormGroup className="fullName-wrapper">
                    <Label htmlFor="NameOnCard" className = {this.state.touched.fullName && !this.state.NameOnCard ? 'error' : ''}>Full Name on Card</Label>
                    <Input
                        id="NameOnCard"
                        value={this.state.NameOnCard}
                        onChange={this.handleChange}
                        name="NameOnCard"
                        onBlur={this.handleBlur('fullName')}
                        className = {this.state.touched.fullName && !this.state.NameOnCard ? 'error' : ''}
                    />
                </FormGroup>
                <FormGroup className="cardNumber-wrapper">
                    <Label htmlFor="CardNumber" className = {this.state.touched.cardNumber && !this.state.CardNumber ? 'error' : ''}>Card Number</Label>
                    <Input
                        id="CardNumber"
                        value={this.state.CardNumber}
                        onChange={this.handleCreditNumChange}
                        name="CardNumber"
                        onBlur={this.handleBlur('cardNumber')}
                        className={this.state.touched.cardNumber && !this.state.CardNumber ? 'error' : ''}
                        placeholder="XXXX XXXX XXXX XXXX"
                        pattern="\d{4} \d{4,6} \d{4,5} \d{4,0}"
                    />
                </FormGroup>
                <div>
                    <FormGroup className="expMonth-wrapper">
                        <Label htmlFor="cardExpMonth" className = {this.state.touched.cardExpMonth && !this.state.CardExpMonth ? 'error' : ''}>Exp Month</Label>
                        <Input
                            id="CardExpMonth"
                            className={this.state.touched.cardExpMonth && !this.state.CardExpMonth ? 'error' : ''}
                            value={this.state.CardExpMonth}
                            onChange={this.hadnleExpMonthChange}
                            name="CardExpMonth"
                            onBlur={this.handleBlur('cardExpMonth')}
                            placeholder="MM"
                            pattern="[0123456789][0123456789]"
                        />
                    </FormGroup>
                    <FormGroup className="expYear-wrapper">
                        <Label htmlFor="CardExpYear" className = {this.state.touched.cardExpYear && !this.state.CardExpYear ? 'error' : ''}>Exp Year</Label>
                        <Input
                            id="CardExpYear"
                            name="CardExpYear"
                            value={this.state.CardExpYear}
                            onChange={this.hanleExpYearChange}
                            onBlur={this.handleBlur('cardExpYear')}
                            className={this.state.touched.cardExpYear && !this.state.CardExpYear ? 'error' : ''}
                            placeholder="YY"
                            pattern="[0123456789][0123456789]"
                        />
                    </FormGroup>
                    <FormGroup className="cvcCode-wrapper">
                        <Label htmlFor="CardCVC" className = {this.state.touched.cardCVC && !this.state.CardCVC ? 'error' : ''}>CVC Code</Label>
                        <Input
                            id="CardCVC"
                            className={this.state.touched.cardCVC && !this.state.CardCVC ? 'error' : ''}
                            value={this.state.CardCVC}
                            onChange={this.hanleCVCChange}
                            name="CardCVC"
                            onBlur={this.handleBlur('cardCVC')}
                        />
                    </FormGroup>
                </div>
                <div className="routingNumber custom-control">
                    {!this.isFreeAccount() ? <div >
                            <input
                                type="checkbox"
                                id="IsAutoRenew"
                                onChange={this.handleChange}
                                name="IsAutoRenew"
                                checked={this.state.IsAutoRenew}
                                onChange={this.handleCheckboxChange}
                            />
                            <label htmlFor="IsAutoRenew">
                                <span className={ this.state.IsAutoRenew ? " far fa-check-square" : "far fa-square"}></span>
                                <span className="custom-control-text">Auto-Renew My Membership Annually</span>
                            </label>

                    </div> : null}
                </div>
                {/* <div className="">
                    {!this.isFreeAccount() ? <div >
                        <label>
                            <input
                                type="checkbox"
                                onChange={this.handleChange}
                                name="IsAutoRenew"
                                value={this.state.IsAutoRenew}
                                checked = {this.state.IsAutoRenew}
                            />
                            Would you like to set your membership to auto-renew every year
                        </label>
                    </div> : null}
                </div> */}
                <div className="vertHorzCenter buttonContainer">
                    <button className="signUpBtns mb-3 btnPrimary" onClick={this.backBtnClick}>Back</button>
                    {
                        this.state.isSubmitting ? <button id="submittingBtn" className="signUpBtns mb-3" disabled><SpanSpinner message="SUBMITTING ..." /></button>
                        : (!this.isFreeAccount() ? <button onClick={this.handleSubmit} className="signUpBtns mb-3 btnPrimary">SUBMIT</button> :
                    <button onClick={this.handleSubmit} className="signUpBtns mb-3 btnPrimary">SUBMIT</button>)}
                    {/* <button href="#" className="secondary" onClick={this.handleACHClick}>Pay From Bank</button> */}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        membership: state.membership,
        billing: state.billing,
        signupWizard: state.signupWizard
    }
}

export default connect(mapStateToProps, { selectPayment, signupSubtract, loader, toastr, resetSignup, setTransactionId })(CardPayment);

